<script setup>
import { PopoverRoot, useForwardPropsEmits } from "reka-ui";

const props = defineProps({});
const emits = defineEmits([]);

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <PopoverRoot v-bind="forwarded">
    <slot />
  </PopoverRoot>
</template>
